import React, { useEffect, useState } from "react";
import toast from "react-hot-toast";
import { dependentsServices } from "../../../../api/services/dependentsServices";
import DownloadDocController from "../../../../domain/myProfile/documents/DownloadDocs/DownloadDocController";
import { setAlldependentslist } from "../../../../infra/aggregates/myProfile/DependentsAggregates/dependentslistSlice";
import { useAppDispatch, useAppSelector } from "../../../../infra/hooks";
import DepDocumentsPresenter from "./DepDocumentsPresenter";

interface ModalInterface {
  isModalOpen: boolean;
  closeModal: any;
  depdDocumentsList: any;
  trans?: any;
}
const DepDocumentsController = ({
  isModalOpen,
  closeModal,
  depdDocumentsList,
  trans,
}: ModalInterface) => {
  const selector = useAppSelector((state) => state.authSlice);
  const empId: any = selector.emp_id;
  const [attachmentUrl, setAttachmentUrl] = useState("");

  const [open_modal, setOpenModal] = useState(false);
  const dispatch = useAppDispatch();

  const getDocsIdItemToBeDeleted = async (id: number) => {
    const response: any = await dependentsServices.deleteDocs(id, empId);
    if (response.response == "success") {
      console.log("Deleted---", response);
      dispatch(setAlldependentslist(response.data));
      toast.success(trans("Deleted Successfully"));
      closeModal(false);
    }
  };
  const full_path = "";
  const getAttchedDocs = async (id: number) => {
    const response: any = await dependentsServices.getAttachedDoc(
      id,
      full_path
    );

    if (response.response == "success") {
      const url = response.data.attachment;
      if (url != "") {
        setAttachmentUrl(url);
        setOpenModal(true);
      } else {
        toast.error(trans("There is no Attachments!"));
      }
    }
  };
  return (
    <>
      <DepDocumentsPresenter
        setDocsIdFordeletion={getDocsIdItemToBeDeleted}
        setDependentAttachedDoc={getAttchedDocs}
        isModalOpen={isModalOpen}
        closeModal={closeModal}
        depdDocumentsList={depdDocumentsList}
        trans={trans}
      />
      {open_modal && (
        <DownloadDocController
          isModalOpen={open_modal}
          closeModal={() => setOpenModal(false)}
          attachmentUrl={attachmentUrl}
        />
      )}
    </>
  );
};
export default DepDocumentsController;
